import cn from "classnames"
import { useRef } from "react"
import { useSelector } from "react-redux"

import style from "./styles.module.scss"

import { Icon } from "components"
import { Message as MessageI, MessageStatus } from "modules/Chat/utils/interfaces"
import { formatToHoursAndMinutes } from "utils/datetime-format-utils"
import { userSelector } from "utils/store/selectors/user"
import { ROLES } from "utils/constants"
import { chatSelector } from "utils/store/selectors/chat"
import { parseLinks } from "modules/Chat/utils/parseLinks"

interface Props {
    message: MessageI
    lastMessage: boolean
}

export function Message({ message, lastMessage }: Props) {
    const { clientHash, psyHash } = useSelector(userSelector)
    const { role } = useSelector(chatSelector)
    const hash = role === ROLES.CLIENT ? clientHash : psyHash
    const ref = useRef<HTMLInputElement>(null)
    const isMyMessage = message.externalUserId === hash

    const getStatusIcon = () => {
        switch (message.status) {
            case MessageStatus.CREATED:
                return <Icon type="done" size={24} />
            case MessageStatus.SENT:
                return ""
            case MessageStatus.VIEWED:
                return <Icon type="done-all" size={24} />
            default:
                return ""
        }
    }

    return (
        <div className={cn(style.container, { [style.right]: isMyMessage })} ref={ref}>
            <div
                className={cn(style.content, {
                    [style.right]: isMyMessage,
                    [style.hasBorderRadiusBottom]: lastMessage,
                })}
            >
                <div>{parseLinks(message.text)}</div>
                <div className={cn(style.time, { [style.rightTime]: isMyMessage })}>
                    {formatToHoursAndMinutes(new Date(message.timestamp))}
                </div>
                {isMyMessage && getStatusIcon()}
            </div>
        </div>
    )
}
